import {
  getListOrganizationApiKeysQueryKey,
  useCreateOrganizationApiKey,
  useListOrganizationApiKeys,
} from "../../api/endpoint.js";
import { keepPreviousData, useQueryClient } from "@tanstack/react-query";
import {
  useApiKeysContext,
  type ApiKeysContextType,
} from "../api-keys/api-keys-context.js";

export const useApiKeys = (context?: ApiKeysContextType) => {
  const {
    state: { pagination, searchQuery },
  } = useApiKeysContext(context);
  const limit = 10;
  const { before, after } = pagination || {};

  return useListOrganizationApiKeys(
    {
      after: after ?? undefined,
      before: before ?? undefined,
      limit,
      search: searchQuery || undefined,
    },
    {
      query: {
        placeholderData: keepPreviousData,
      },
    },
  );
};

export const useCreateApiKey: typeof useCreateOrganizationApiKey = () => {
  const queryClient = useQueryClient();

  return useCreateOrganizationApiKey({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getListOrganizationApiKeysQueryKey(),
        });
      },
    },
  });
};
